import styled from "styled-components"

export const Container = styled.div`
    width: 100%;
    height: fit-content;
    position: relative;
    margin: 30px auto;

    h2{
        text-transform: uppercase;
        margin: 50px auto;
        text-align: center;
    }

    .coluna-img{
        width: 100%;
        margin: 20px auto;
        cursor: pointer;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;

        }
    }
`

export const Modal = styled.div`
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, .9);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    justify-content: center;
    align-items: center;
    overflow: hidden;

    display: ${({isOpenModal}) => isOpenModal ? 'flex': 'none'};

    .icone-fechar{
        cursor: pointer;
        position: fixed;
        color: #fff;
        top: 100px;
        right: 30px;
        font-size: 3.2rem;

        &:hover{
            color: #ff0000;
        }
    }

    img{
        pointer-events: none;
        display: block;
        width: 100%;
        height: 100%;
        object-fit: cover;
        margin: 0 auto;
        margin-top: 50px;
    }
`